import { useMutation, } from '@apollo/client';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { heapTrackEvent } from '@marvelapp/core';
import { CREATE_MULTISTEP_USER_TEST, CREATE_MULTISTEP_USER_TEST_WITH_DOCUMENT, } from './graphql/createMultistepUserTest';
import GET_PROJECT_COUNT from './graphql/getProjectCount';
export function useCreateUserTest({ projectToCloneUUID, showError, }) {
    const history = useHistory();
    const [createProjectMutation, { data, loading }] = useMutation(CREATE_MULTISTEP_USER_TEST, {
        onError: (error) => {
            if (error.message === 'GraphQL error: User has hit their project quota') {
                history.replace('/plans?intent=reached-project-limit');
            }
            showError();
        },
        refetchQueries: [{ query: GET_PROJECT_COUNT }],
    });
    const createProject = useCallback((options, historyState) => {
        return createProjectMutation(Object.assign(Object.assign({}, options), { onCompleted: (mutationResponse) => {
                if (!mutationResponse.createMultistepUserTest.ok) {
                    showError();
                    return;
                }
                const { pk: projectPk } = mutationResponse.createMultistepUserTest.project;
                const cloneFromParam = projectToCloneUUID
                    ? `?from=${projectToCloneUUID}`
                    : '';
                const projectURL = `/project/${projectPk}${cloneFromParam}`;
                heapTrackEvent('Prototype Project Create', {
                    createdInFolder: false,
                });
                console.log('historyState', historyState);
                history.replace(projectURL, historyState);
            } }));
    }, [createProjectMutation, history, projectToCloneUUID, showError]);
    return {
        createProject,
        data,
        loading,
        hasSucceeded: data === null || data === void 0 ? void 0 : data.createMultistepUserTest.ok,
    };
}
export function useCreateUserTestWithDocument({ showError, }) {
    const history = useHistory();
    const [createProjectWithDocumentMutation, { data, loading }] = useMutation(CREATE_MULTISTEP_USER_TEST_WITH_DOCUMENT, {
        onError: (error) => {
            if (error.message === 'GraphQL error: User has hit their project quota') {
                history.replace('/plans?intent=reached-project-limit');
            }
            showError();
        },
        refetchQueries: [{ query: GET_PROJECT_COUNT }],
    });
    const createProjectWithDocument = useCallback((options, historyState) => {
        return createProjectWithDocumentMutation(Object.assign(Object.assign({}, options), { onCompleted: (mutationResponse) => {
                if (!mutationResponse.createMultistepUserTest.ok) {
                    showError();
                    return;
                }
                const { pk: projectPk } = mutationResponse.createMultistepUserTest.project;
                const projectURL = `/project/${projectPk}`;
                heapTrackEvent('Prototype Project Create', {
                    createdInFolder: false,
                });
                history.replace(projectURL, historyState);
            } }));
    }, [createProjectWithDocumentMutation, history, showError]);
    return {
        createProjectWithDocument,
        data,
        loading,
        hasSucceeded: data === null || data === void 0 ? void 0 : data.createMultistepUserTest.ok,
    };
}
